module.exports = __webpack_public_path__ + "static/media/chevron-down-light-grey.19808021.svg";